import {Injectable} from '@angular/core';
import {SearchState} from '../types/SearchState';
import {SortConditionsFieldsEnum} from '../enums/SearchEnums';
import {DefaultPage} from '../app-common/const';
import {UserLocationState} from '../types/UserLocationState';
import {ToolsService} from './tools.service';
import {SearchResultContent} from '../types/SearchResultContent';
import {SearchResultsDescription} from '../types/SearchResultsDescription';
import {AppConfigService} from './app-config.service';
import {RoutesAddonsEnums} from '../enums/RoutesEnums';

@Injectable({
  providedIn: 'root',
})
export class DefaultValuesService {
  private defaultSearchState: SearchState = {
    caregiverUnitTypeUrlPath: '',
    careServiceTypeUrlPath: '',
    symptomUrlPath: '',
    placeUrlPath: '',
    freeSearchTerm: '',
    sort: SortConditionsFieldsEnum.ES_SCORE,
    page: DefaultPage,
    pageSize: 10,
    totalPages: 1,
    locationSearch: false,
    lat: 0,
    lon: 0,
    openNow: false,
    openWeekend: false,
    customerFeatureType: '',
    isValid: true,
    digitalPage: DefaultPage,
    timeslot: null,
    attributes: {},
    forceContentPage: false,
    forceSearchResults: false,
    urlPath: '',
    distance: null,
    tab: null,
  };

  private defaultUserLocationState: UserLocationState = {
    locationSearch: false,
    lat: 0,
    lon: 0,
  };

  private searchResultContent: SearchResultContent = {
    allSolved: false,
    breadcrumbs: [],
    caregiverUnitType: null,
    careServiceType: null,
    freeText: '',
    parentPlace: '',
    place: null,
    symptom: null,
  };

  private searchResultDescription: SearchResultsDescription = {
    description: '',
    introduction: '',
    title: '',
  };

  constructor(
    private tools: ToolsService,
    private appConfigService: AppConfigService,
  ) {
    this.defaultSearchState.pageSize = appConfigService.appConfig.pageSize;
  }

  public getDefaultSearchState(
    caregiverUnitTypeUrlPath?: string,
    careServiceTypeUrlPath?: string,
    symptomUrlPath?: string,
    freeSearchTerm?: string,
  ): SearchState {
    const state: SearchState = this.tools.clone(this.defaultSearchState);
    if (
      !this.tools.isNil(careServiceTypeUrlPath) &&
      careServiceTypeUrlPath !== '' &&
      !this.tools.isNil(caregiverUnitTypeUrlPath) &&
      caregiverUnitTypeUrlPath === '' &&
      !this.tools.isNil(symptomUrlPath) &&
      symptomUrlPath === '' &&
      !this.tools.isNil(freeSearchTerm) &&
      freeSearchTerm === ''
    ) {
      state.tab = RoutesAddonsEnums.SERP_SERVICES;
    } else if (
      (!this.tools.isNil(caregiverUnitTypeUrlPath) && caregiverUnitTypeUrlPath !== '') ||
      (!this.tools.isNil(symptomUrlPath) && symptomUrlPath !== '') ||
      (!this.tools.isNil(freeSearchTerm) && freeSearchTerm !== '')
    ) {
      state.tab = RoutesAddonsEnums.SERP_CAREPROVIDERS;
    }
    return state;
  }

  public getDefaultUserLocationState(): UserLocationState {
    return this.defaultUserLocationState;
  }

  public getSearchResultContent(): SearchResultContent {
    return this.searchResultContent;
  }

  public getSearchResultDescription(): SearchResultsDescription {
    return this.searchResultDescription;
  }
}
